import api from "@/api/client";
import type { AxiosRequestConfig } from "axios";

export type LeafletEnquirySummary = {
  assigned_leaflet_enquiry_count: number;
};

export async function fetchLeafletEnquirySummary(): Promise<LeafletEnquirySummary> {
  const config: AxiosRequestConfig & { suppressGlobalErrorToast?: boolean } = {
    suppressGlobalErrorToast: true,
  };
  const res = await api.get<LeafletEnquirySummary>("leaflet-enquiries/summary/", config);
  return res.data;
}
